// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.configGroupsMain {
  width: calc(100% - 40px);
}

.configGroupsTabContent {
  margin: 24px 24px 0 35px;
  padding: 24px 28px;
  border: 1px solid #cfd1d2;
  background: #fff;
}

.configGroupsTabContent h2 {
  margin: 0;
  color: #000;
  font-size: 18px;
}

.configGroupsTabContent p {
  margin: 12px 0 0;
  color: #4d4d4d;
  font-size: 14px;
}

.configGroupsNotFound {
  margin: 35px;
  padding: 32px;
  border: 1px solid #cfd1d2;
  border-left: 4px solid #e20015;
  background: #fff;
}

.configGroupsNotFound h1 {
  margin: 0;
  font-size: 22px;
}

.configGroupsNotFound p {
  margin: 12px 0 24px;
  color: #4d4d4d;
  font-size: 14px;
}

.configGroupsBackButton {
  min-height: 44px;
  padding: 0 20px;
  border: 2px solid #007bc0;
  border-radius: 2px;
  background: #007bc0;
  color: #fff;
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
}

.configGroupsBackButton:hover {
  background: #00629a;
}

@media (max-width: 700px) {
  .configGroupsMain {
    width: 100%;
  }

  .configGroupsTabContent,
  .configGroupsNotFound {
    margin-left: 20px;
    margin-right: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ConfigGrupos/ConfigGrupos.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".configGroupsMain {\n  width: calc(100% - 40px);\n}\n\n.configGroupsTabContent {\n  margin: 24px 24px 0 35px;\n  padding: 24px 28px;\n  border: 1px solid #cfd1d2;\n  background: #fff;\n}\n\n.configGroupsTabContent h2 {\n  margin: 0;\n  color: #000;\n  font-size: 18px;\n}\n\n.configGroupsTabContent p {\n  margin: 12px 0 0;\n  color: #4d4d4d;\n  font-size: 14px;\n}\n\n.configGroupsNotFound {\n  margin: 35px;\n  padding: 32px;\n  border: 1px solid #cfd1d2;\n  border-left: 4px solid #e20015;\n  background: #fff;\n}\n\n.configGroupsNotFound h1 {\n  margin: 0;\n  font-size: 22px;\n}\n\n.configGroupsNotFound p {\n  margin: 12px 0 24px;\n  color: #4d4d4d;\n  font-size: 14px;\n}\n\n.configGroupsBackButton {\n  min-height: 44px;\n  padding: 0 20px;\n  border: 2px solid #007bc0;\n  border-radius: 2px;\n  background: #007bc0;\n  color: #fff;\n  cursor: pointer;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.configGroupsBackButton:hover {\n  background: #00629a;\n}\n\n@media (max-width: 700px) {\n  .configGroupsMain {\n    width: 100%;\n  }\n\n  .configGroupsTabContent,\n  .configGroupsNotFound {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
